import * as angular from "angular";
import * as _ from "lodash";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";


export class OmsOrdersAlertsService {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  // CREATE //
  createSuccess() {
    const message = {
      body: 'OMS_ORDERS_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createSuccessWithView(order, isDraft: boolean) {
    const message = {
      body: isDraft ? 'X_OMS_ORDER_CREATE_DRAFT_SUCCESS' : 'X_OMS_ORDER_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message, {id: order.id}, 'View')
  }

  createError(error) {
    const message = {
      body: 'OMS_ORDERS_CREATE_ERROR',
      message: _.get(error, 'more_info'),
      details: _.get(error, 'more_info') ? undefined : 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CREATE_DRAFT //
  createDraftSuccess() {
    const message = {
      body: 'OMS_ORDERS_CREATE_DRAFT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createDraftError() {
    const message = {
      body: 'OMS_ORDERS_CREATE_DRAFT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE //
  updateSuccess() {
    const message = {
      body: 'OMS_ORDERS_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateError(error) {
    const message = {
      body: 'OMS_ORDERS_UPDATE_ERROR',
      message: _.get(error, 'message'),
      details: _.get(error, 'more_info') ? undefined : 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  updateInfo(error) {
    const message = {
      details: 'OMS_ORDERS_UPDATE_SUCCESS',
      message: _.get(error, 'message')
    };
    return this.bringozToastService.info(message)
  }

  // UPDATE SETTINGS //
  updateSettingsSuccess() {
    const message = {
      body: 'OMS_ORDERS_UPDATE_SETTINGS_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateSettingsError() {
    const message = {
      body: 'OMS_ORDERS_UPDATE_SETTINGS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CANCEL //
  cancelSuccess() {
    const message = {
      body: 'OMS_ORDERS_CANCEL_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  cancelError() {
    const message = {
      body: 'OMS_ORDERS_CANCEL_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CANCEL MANY //
  cancelManySuccess() {
    const message = {
      body: 'OMS_ORDERS_CANCEL_MANY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  cancelManyError() {
    const message = {
      body: 'OMS_ORDERS_CANCEL_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // ADDED //
  addedInfo(order?: any, enableView?: boolean) {
    const message = {
      body: 'OMS_ORDERS_CREATED_INFO'
    };
    const view = enableView ? 'View' : null;
    return this.bringozToastService.info(message, {id: order.id}, view, 4000);
  }

  // ADDED MANY//
  addedManyInfo(count) {
    const message = {
      body: 'X_OMS_ORDERS_ADDED_MANY_INFO'
    };
    return this.bringozToastService.info(message, {count: count})
  }

  // SCHEDULE //
  scheduleOrderSuccess() {
    const message = {
      body: 'OMS_SCHEDULE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  scheduleOrderError() {
    const message = {
      body: 'OMS_SCHEDULE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // ASSIGN_SHIPMENT //
  assignShipmentSuccess() {
    const message = {
      body: 'OMS_ASSIGN_SHIPMENT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  assignShipmentError() {
    const message = {
      body: 'OMS_ASSIGN_SHIPMENT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // ADD_NOTE //
  addNoteSuccess() {
    const message = {
      body: 'OMS_ADD_NOTE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  addNoteError() {
    const message = {
      body: 'OMS_ADD_NOTE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // SET ORDER ON HOLD //
  setOrderOnHoldSuccess() {
    const message = {
      body: 'OMS_SET_ORDER_ON_HOLD_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  setOrderOnHoldError() {
    const message = {
      body: 'OMS_SET_ORDER_ON_HOLD_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  cannotSetOrderOnHoldError(error) {
    const message = {
      body: 'OMS_CANNOT_SET_ORDER_ON_HOLD_ERROR',
      message: _.get(error, 'more_info'),
      details: _.get(error, 'more_info') ? undefined : 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


  // SET ORDER ON HOLD //
  resumeOrderSuccess() {
    const message = {
      body: 'OMS_RESUME_ORDER_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  resumeOrderError() {
    const message = {
      body: 'OMS_RESUME_ORDER_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // SET ORDER ON HOLD //
  manuallyCompleteOrderSuccess() {
    const message = {
      body: 'OMS_MANUALLY_COMPLETE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  manuallyCompleteOrderError() {
    const message = {
      body: 'OMS_MANUALLY_COMPLETE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // SEND SCHEDULING SMS SENT //
  sendSchedulingMsgSuccess() {
    const message = {
      body: 'OMS_SCHEDULING_MSG_SENT'
    };
    return this.bringozToastService.success(message)
  }

  sendSchedulingMsgError() {
    const message = {
      body: 'OMS_SCHEDULING_MSG_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getSchedulingFormError() {
    const message = {
      body: 'OMS_GET_SCHEDULING_FORM_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  dispatchBulkSuccess() {
    const message = {
      body: 'DISPATCH_BULK_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  dispatchBulkError() {
    const message = {
      body: 'DISPATCH_BULK_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  recoverSuccess() {
    const message = {
      body: 'OMS_ORDER_RECOVER_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  recoverError(error) {
    const message = {
      body: 'OMS_ORDER_RECOVER_ERROR',
      message: _.get(error, 'more_info'),
      details: _.get(error, 'more_info') ? undefined : 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getOrderTaskTimeSlotsError() {
    const message = {
      body: 'TASK_TIMESLOT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getBOLError() {
    const message = {
      body: 'GET_BOL_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  autoDispatchSuccess() {
    const message = {
      body: 'OMS_ORDERS_AUTO_DISPATCH_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  autoDispatchError(error) {
    const message = {
      body: 'OMS_ORDERS_AUTO_DISPATCH_ERROR',
      message: _.get(error, 'more_info'),
      details: _.get(error, 'more_info') ? undefined : 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getTimelineError() {
    const message = {
      body: 'OMS_ORDERS_GET_TIMELINE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getGlobalSearchError() {
    const message = {
      body: 'GLOBAL_SEARCH_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // VIEW SETTINGS //
  viewSettingsSuccess() {
    const message = {
      body: 'DELIVERY_VIEW_SETTINGS_SUCCESS_DETAILS',
      details: 'DELIVERY_VIEW_SETTINGS_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  viewSettingsError() {
    const message = {
      body: 'DELIVERY_VIEW_SETTINGS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // EMAIL_BOL //
  emailBOLSuccess() {
    const message = {
      body: 'EMAIL_BOL_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  emailBOLError() {
    const message = {
      body: 'EMAIL_BOL_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  validateServiceAreasError() {
    const message = {
      body: 'VALIDATE_SERVICE_AREAS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CANCEL_FULFILLMENT_LINES //
  cancelFulfillmentLinesSuccess() {
    const message = {
      body: 'OMS_CANCEL_FULFILLMENT_LINES_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  cancelFulfillmentLinesError() {
    const message = {
      body: 'OMS_CANCEL_FULFILLMENT_LINES_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CANCEL_FULFILLMENT_LINES //
  bulkUpdateOrdersSuccess() {
    const message = {
      body: 'OMS_BULK_UPDATE_ORDERS_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  bulkUpdateOrdersError(error?) {
    const message = {
      body: 'OMS_BULK_UPDATE_ORDERS_ERROR',
      details: 'SOMETHING_WENT_WRONG',
      message: _.get(error, 'message')
    };
    return this.bringozToastService.error(message)
  }

  // CANCEL_FULFILLMENT_LINES //
  deleteOrderNoteSuccess() {
    const message = {
      body: 'DELETE_NOTE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteOrderNoteError() {
    const message = {
      body: 'DELETE_NOTE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // EXPORT //
  exportOmsOrdersTableSuccess() {
    const message = {
      body: 'OMS_TABLE_EXPORT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  exportOmsOrdersTableError() {
    const message = {
      body: 'OMS_TABLE_EXPORT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


  // UPLOAD //
  uploadSuccess() {
    const message = {
      body: 'OMS_ORDERS_UPLOAD_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }
  uploadError() {
    const message = {
      body: 'OMS_ORDERS_UPLOAD_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

}

angular
  .module('bringoz.admin.oms')
  .service('omsOrdersAlertsService', OmsOrdersAlertsService);
